import React from 'react'
import { test } from 'src/assets/images'
import { Button } from 'src/components/common';
import cx from './suggestedProgramCard.module.scss';
import { TProgramList } from 'src/services/apiEndpoint.types.ts';
import { formatDate } from 'src/utils';
import IncubatorBadge from 'src/assets/images/svg/IncubatorBadge.svg';

export default function SuggestedProgramCard({ program }: { program: TProgramList }) {
    const about = program?.programDetails?.find((item) => item?.label === 'bout Program')
    const handleApplyToProgram = () => {
        window.open(`/apply-to-program-external?id=${program?.id}`, '_blank', 'noopener,noreferrer');
      };
      console.log(program?.banner?.url, 'progra,dAta');
      
    return (
        <div className={`${cx.outer_box}`}>
            <div className={`${cx.imageBox}`}>
                <img
                    src={program?.banner?.url || program.Company.logo || test}
                    alt="meeting-img"
                />
            </div>
            <div className={`${cx.companyDetails}`}>
                <div className={`${cx.imgBox}`}>
                    {program.Company.logo && <img src={program.Company.logo} alt="company-logo" />}
                    {!program.Company.logo && (
                        <div className={cx.fakelogo}>
                            <span>{program.Company.name?.[0]}</span>
                        </div>
                    )}
                </div>
                <h5 className={cx.companyName} title={program.Company.name}>{program.Company.name}<img style= {{ marginLeft: "8px", height: "20px", width: "20px", marginBottom: "2px" }} src={IncubatorBadge} alt="  Incubator" /></h5>
            </div>
            <div className={`${cx.program_heading}`}>
                <h4 title={program.title}>{program.title}</h4>
                <div className={`${cx.marketplace_content}`}>
                End date: {formatDate({ dateString: program?.endDate })}
                    {/* {about?.values && <p dangerouslySetInnerHTML={{ __html: about?.values }} />}
                    {!about?.values && <p role='img' className={`${cx.zeroOpatity}`}>dddddddddddddd hhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhh hhhhhhhhhhhhhh hhhhhhhhhhhhh hhhhhhhhhhh </p>} */}
                </div>
                <div className={`${cx.ctaButton}`}>
                    <Button size="small" variant="secondary" type="submit" onClick={handleApplyToProgram}>
                        View / Apply
                    </Button>
                </div>
            </div>
        </div>
    )
}
